import { forwardRef } from "react";
import { useId } from "react";
function SvgRawBrickedOffDoorIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={205}
      height={181}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#DEECFF"
        d="M2.298 93.879c-7.402 29.416 13.111 50.81 32.35 56.926 27.414 8.716 74.019 7.354 106.643 4.903 32.623-2.452 59.764-4.903 62.779-38.133 3.016-33.23-16.723-28.872-23.851-55.564-7.127-26.693-9.595-56.382-54.829-61.557C80.156-4.721 80.704 35.863 55.483 45.94 30.26 56.019 9.7 64.463 2.298 93.88Z"
      />
      <circle
        cx={140.412}
        cy={45.788}
        r={2.941}
        fill="#fff"
        transform="rotate(-44.127 140.412 45.788)"
      />
      <circle
        cx={174.629}
        cy={64.069}
        r={0.916}
        fill="#80B5FF"
        opacity={0.5}
        transform="rotate(-44.127 174.629 64.069)"
      />
      <circle
        cx={44.853}
        cy={110.838}
        r={2.749}
        fill="#80B5FF"
        opacity={0.5}
        transform="rotate(-44.127 44.853 110.838)"
      />
      <circle
        cx={137.549}
        cy={51.852}
        r={0.916}
        fill="#fff"
        transform="rotate(-44.127 137.549 51.852)"
      />
      <circle
        cx={165.251}
        cy={33.528}
        r={0.916}
        fill="#fff"
        transform="rotate(-44.127 165.251 33.528)"
      />
      <circle
        cx={165.251}
        cy={73.879}
        r={0.916}
        fill="#fff"
        transform="rotate(-44.127 165.251 73.879)"
      />
      <circle
        cx={108.303}
        cy={21.331}
        r={1.832}
        fill="#fff"
        transform="rotate(-44.127 108.303 21.331)"
      />
      <circle
        cx={187.463}
        cy={121.257}
        r={1.832}
        fill="#fff"
        transform="rotate(-44.127 187.463 121.257)"
      />
      <path
        fill="#fff"
        d="m29.684 79.202 2.662 3.402a.683.683 0 0 0 .583.257l4.252-.313a.673.673 0 0 1 .366.08.713.713 0 0 1 .254 1l-2.345 3.638a.727.727 0 0 0-.062.648l1.608 4.036a.71.71 0 0 1-.121.726.68.68 0 0 1-.692.21l-4.11-1.156a.674.674 0 0 0-.623.141l-3.23 2.806a.676.676 0 0 1-.715.109.686.686 0 0 1-.29-.244.707.707 0 0 1-.119-.364l-.197-4.352a.711.711 0 0 0-.32-.56l-3.622-2.299a.71.71 0 0 1-.181-1.017.683.683 0 0 1 .302-.227l3.985-1.54a.682.682 0 0 0 .423-.484l1.021-4.229a.7.7 0 0 1 .188-.317.678.678 0 0 1 .681-.156c.117.04.221.11.302.205ZM140.76 69.336l1.704 2.094a.433.433 0 0 0 .373.158l2.721-.192a.447.447 0 0 1 .408.212.425.425 0 0 1-.011.453l-1.5 2.238a.428.428 0 0 0-.04.399l1.029 2.483a.419.419 0 0 1-.078.448.435.435 0 0 1-.442.128l-2.63-.71a.45.45 0 0 0-.4.086l-2.067 1.727a.44.44 0 0 1-.457.067.429.429 0 0 1-.262-.374l-.126-2.679a.429.429 0 0 0-.205-.344l-2.318-1.415a.432.432 0 0 1-.204-.406.43.43 0 0 1 .281-.36l2.551-.947a.437.437 0 0 0 .271-.298l.653-2.603a.434.434 0 0 1 .556-.29.43.43 0 0 1 .193.125ZM80.29 122.478l1.703 2.093a.443.443 0 0 0 .374.158l2.72-.192a.439.439 0 0 1 .407.212.426.426 0 0 1-.01.453l-1.5 2.238a.435.435 0 0 0-.04.399l1.03 2.484a.42.42 0 0 1-.078.447.438.438 0 0 1-.443.128l-2.63-.711a.44.44 0 0 0-.21-.004.442.442 0 0 0-.19.091l-2.067 1.727a.443.443 0 0 1-.642-.083.426.426 0 0 1-.077-.224l-.126-2.679a.424.424 0 0 0-.205-.344l-2.317-1.414a.422.422 0 0 1 .077-.766l2.55-.947a.444.444 0 0 0 .271-.299l.653-2.602a.44.44 0 0 1 .75-.165ZM175.91 89.817l-1.121 1.845a.36.36 0 0 0-.028.32l.779 2.023a.387.387 0 0 1-.073.35.35.35 0 0 1-.145.103.325.325 0 0 1-.173.016l-1.976-.569a.327.327 0 0 0-.298.07l-1.561 1.414a.327.327 0 0 1-.335.035.346.346 0 0 1-.137-.115.388.388 0 0 1-.068-.171l-.103-2.181a.361.361 0 0 0-.156-.28l-1.731-1.148a.346.346 0 0 1-.123-.141.359.359 0 0 1 .033-.369.323.323 0 0 1 .146-.113l1.914-.775a.37.37 0 0 0 .2-.247l.485-2.122a.346.346 0 0 1 .251-.239.325.325 0 0 1 .174.006.34.34 0 0 1 .149.096l1.284 1.701c.033.045.076.08.125.103a.3.3 0 0 0 .156.026l2.045-.162a.31.31 0 0 1 .166.044.36.36 0 0 1 .121.48Z"
        opacity={0.8}
      />
      <path
        fill="#AFD0FF"
        d="m169.463 116.718-1.121 1.845a.357.357 0 0 0-.028.321l.779 2.022a.385.385 0 0 1-.074.35.349.349 0 0 1-.144.103.322.322 0 0 1-.174.015l-1.976-.568a.33.33 0 0 0-.297.07l-1.561 1.413a.333.333 0 0 1-.473-.079.386.386 0 0 1-.067-.172l-.104-2.18a.36.36 0 0 0-.155-.281l-1.731-1.147a.344.344 0 0 1-.123-.141.364.364 0 0 1 .033-.369.326.326 0 0 1 .146-.114l1.913-.775a.36.36 0 0 0 .201-.247l.485-2.122a.369.369 0 0 1 .096-.154.331.331 0 0 1 .478.018l1.284 1.701a.307.307 0 0 0 .28.129l2.046-.162a.298.298 0 0 1 .166.044c.05.03.093.074.122.127a.363.363 0 0 1 .044.177.36.36 0 0 1-.045.176Z"
        opacity={0.8}
      />
      <path fill="#C5DDFF" d="M50.578 23.446h110.663v141.611H50.578z" />
      <path fill="#106FF3" d="M58.081 30.948h95.658v134.109H58.081z" />
      <path fill="#99C4FF" d="M59.956 32.824h93.782v132.233H59.956z" />
      <rect
        width={18.756}
        height={7.503}
        x={65.583}
        y={38.451}
        fill="#AFD0FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={65.583}
        y={59.083}
        fill="#C6DDFF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={65.583}
        y={79.715}
        fill="#AFD0FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={76.837}
        y={90.031}
        fill="#106FF3"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={65.583}
        y={111.601}
        fill="#F4F8FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={65.583}
        y={143.487}
        fill="#106FF3"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={87.153}
        y={38.451}
        fill="#C6DDFF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={87.153}
        y={79.715}
        fill="#F3F8FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={87.153}
        y={111.601}
        fill="#AFD0FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={87.153}
        y={143.487}
        fill="#C6DDFF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={76.837}
        y={48.767}
        fill="#106FF3"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={76.837}
        y={69.399}
        fill="#AFD0FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={76.837}
        y={121.917}
        fill="#F3F8FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={98.407}
        y={48.767}
        fill="#AFD0FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={98.407}
        y={90.031}
        fill="#AFD0FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={108.723}
        y={59.083}
        fill="#AFD0FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={106.847}
        y={100.347}
        fill="#AFD0FF"
        rx={1}
      />
      <rect
        width={18.756}
        height={7.503}
        x={108.723}
        y={143.487}
        fill="#106FF3"
        rx={1}
      />
      <path fill="#fff" d="M118.101 14.067h6.565V181h-6.565z" />
      <path
        fill="#6397FC"
        d="m124.666 14.067 29.073 16.694v133.546L124.666 181V14.067Z"
      />
      <path fill="#fff" d="M129.355 85.342h6.565v4.689h-6.565z" />
      <path
        fill="#1C4CA9"
        d="m135.92 85.342 6.565 3.751v2.814l-6.565-1.876v-4.689Z"
      />
      <rect
        width={1.876}
        height={16.881}
        x={152.801}
        y={52.518}
        fill="#1C4CA9"
        rx={0.938}
      />
      <rect
        width={1.876}
        height={16.881}
        x={152.801}
        y={124.73}
        fill="#1C4CA9"
        rx={0.938}
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawBrickedOffDoorIcon);
export default ForwardRef;
